import { Col, Row } from 'antd';
import Gateways from 'features/User/components/Gateways/Gateways';
import MenuUser from 'features/User/components/MenuUser/MenuUser';
import Plants from 'features/User/components/Plants/Plants';
import Viewers from 'features/User/components/Viewers/Viewers';
import * as React from 'react';
import style from './UserManagement.module.scss';
export interface ManagementUserProps {}

export default function ManagementUser(props: ManagementUserProps) {
  const [isShowItem, setIsShowItem] = React.useState<string>('Plant');

  function renderSwitch(param: string) {
    switch (param) {
      case 'Gateways':
        return <Gateways />;
      case 'Viewer':
        return <Viewers />;
      default:
        return <Plants />;
    }
  }

  return (
    <Row align={'middle'} className={style.root}>
      <Row align={'middle'} className={style.container}>
        <Col span={7} className={style.menu_user}>
          <MenuUser isShowItem={isShowItem} setIsShowItem={setIsShowItem} />
        </Col>
        <Col span={17} className={style.content}>
          {renderSwitch(isShowItem)}
        </Col>
      </Row>
    </Row>
  );
}
